var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeEarlyBird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.162 4.622c2.55-.232 4.75.754 5.43 3.088h2.6L20.03 9.206l2.162.666-2.571 1.185c-.82 4.149-4.127 8.356-8.856 8.356-4.946 0-7.536-3.056-8.647-6.762 3.088 0 4.677-1.081 6.177-3.706 1.235-2.162 2.47-4.014 5.867-4.323zm1.543 2.47a1.544 1.544 0 10.001 3.088 1.544 1.544 0 000-3.088z",
    fill: "currentColor"
  })));
}
SvgPokerGameTypeEarlyBird.displayName = 'PokerGameTypeEarlyBird';
export default SvgPokerGameTypeEarlyBird;